import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = `
  display: flex;
  flex: 1;
  margin-top: ${px2rem(20)};
`;

export default buildStyledComponent(
  'ResultWrapper',
  styled.div,
  styles,
);



// WEBPACK FOOTER //
// ./compositions/ServiceProviderSelectionStep/ResultWrapper.js